import { Profile } from 'oidc-client';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { RouteParams } from '../../../../core/models/RouteHelper';
import { MatchDetailVm } from '../../../../utils/api';
import MatchDetails from './MatchDetails';

interface OwnProps {
    userProfile: Profile;
    isInitialEdit: boolean;
    matchFromProps: MatchDetailVm;
    refreshAfterSave: () => Promise<void>;
}

export type Props = OwnProps & RouteComponentProps<RouteParams>;

export default withRouter(MatchDetails);
